import {
    MANDATORY_CREW_TOTALS_INITIAL_VALUES,
    MANDATORY_STATISTICS_INITIAL_VALUES,
    STATISTICS_PAGINATED_INITIAL_VALUES,
} from '@routes/sidebar/admin-center/___shared___/dashboards/constants.ts';
import type { FleetStatistics } from '@routes/sidebar/admin-center/___shared___/dashboards/types.ts';

export const FLEET_STATISTICS_INITIAL_STATE: FleetStatistics = {
    totalCrewWithMandatoryRequirements: 0,
    statisticsSummary: {
        statistics: [],
        mandatoryStatistics: MANDATORY_STATISTICS_INITIAL_VALUES,
    },
    vesselStatistics: STATISTICS_PAGINATED_INITIAL_VALUES,
    ...MANDATORY_CREW_TOTALS_INITIAL_VALUES,
};
